import React, { Component, ErrorInfo, ReactNode } from 'react';
import Logo from '../assets/logo.svg';
import styles from '../pages/Error/error.module.scss'
interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("ErrorBoundary caught an error", error, info);
  }

  render() {
    if (this.state.hasError) {
      <div className="content-wrapper">
        <div className={`white-box flex justify-content-center align-items-center ${styles.box}`}>
          <div className='logo-wrapper flex flex-column align-items-center'>
            <img src={Logo} alt='Logo' className={`${styles.mLogo}`} />

            <h1>Something went wrong</h1>

          </div>
        </div>
      </div>
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
